<template>
  <div></div>
  <!--div>
    <v-row>
      <v-col
        cols="12"
        lg="3"
      >
        <base-card>
          <v-card-title class="flex-column">
            <v-img
              height="128"
              width="128"
              src="@/assets/images/drm.png"
              class=" rounded-circle"
              alt=""
              :src="channel.logoId ? 'https://playout006.noisypeak.com/api/v1/upload/' + channel.logoId + '?img.crop=128x128' : defaultIcon"
            />
          </v-card-title>
          <v-card-text>
            <div class="d-flex align-center justify-center mb-6">
              <div class="text-center">
                <h5 class="font-weight-bold my-3">
                  {{ channel.name }}
                </h5>
                <div
                  class="d-flex align-center flex-wrap justify-center mb-3"
                >
                  <span class="text--disabled">{{ channel.instance.name }}</span>
                </div>

                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="300"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      label
                      small
                      class="ma-2 text--primary"
                      outlined
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      change channel
                    </v-chip>
                  </template>

                  <v-card class="pa-3">
                    <v-subheader>Select channel</v-subheader>
                    <v-divider />
                    <v-autocomplete
                      v-model="channel"
                      :items="channels"
                      return-object
                      item-text="name"
                      filled
                      @change="changeChannel"
                    >
                      <template v-slot:selection="{ item }">
                        {{ item.name }}
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title
                            style="max-width: 200px; "
                            v-text="item.name"
                          />
                          <v-list-item-subtitle v-text="item.instance.name" />
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-card>
                </v-menu>
              </div>
            </div>
            <v-divider class="my-4" />
            <v-list rounded>
              <v-subheader>TEMPLATE TYPES</v-subheader>
              <v-list-item-group
                v-model="item"
                color="primary"
              >
                <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text" />
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </base-card>
      </v-col>
      <v-col
        cols="12"
        lg="9"
      >
        <div class="d-flex align-center">
          <p class="font-weight-medium mr-3 mb-3">
            Current template
          </p>
          <v-divider />
        </div>

        <base-card class="mb-4">
          <v-card-text class="">
            <v-row no-gutters>
              <v-col
                cols="12"
                md="6"
                class="overflow-hidden"
              >
                <div class="mr-4">
                  <img
                    class="md:w-6/12"
                    :src="'https://sotalcloud.blob.core.windows.net/publicstorage/playout/ad_placeholder.png'"
                  >
                </div>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <div class="pa-3">
                  <h4>Simple placeholder template.</h4>
                  <div class="d-flex">
                    <v-btn
                      color="primary"
                      class="mr-2"
                    >
                      Edit
                    </v-btn>
                    <v-btn
                      outlined
                      color="primary"
                      class="mr-2"
                    >
                      Preview
                    </v-btn>
                  </div>
                  <p class="p-t-20">
                    The #1 Best-Selling Gaming Peripherals Manufacturer
                    in the US: Source - The NPD Group, Inc., U.S. Retail
                    Tracking Service, Gaming Designed: Keyboards, Mice,
                    PC Headsets, and PC Microphones, Based on dollar
                    sales, Jan. 2017- June 2020 combined.
                  </p>
                  <div>
                    <p class="text-md text mb-1">
                      <span class="font-weight-medium">Editable:</span> <span>background, logos, text</span>
                    </p>
                    <p class="text-md text">
                      <span class="font-weight-medium">Duration:</span> <span> 1m30s</span>
                    </p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </base-card>

        <div class="d-flex align-center">
          <p class="font-weight-medium mr-3 mb-3">
            Available templates
          </p>
          <v-divider />
        </div>

        <base-card class="mb-4">
          <v-card-text class="">
            <v-row>
              <v-col
                v-for="template in availableTemplates"
                :key="template.id"
                cols="12"
                md="6"
              >
                <base-card class="h-full">
                  <div class="">
                    <img
                      class="md:w-6/12"
                      :src="template.pictureURL"
                      alt=""
                    >

                    <v-card-text>
                      <p class="text-18 ma-0 ">
                        <a href="#">
                          {{ template.name }}
                        </a>
                      </p>
                      <p
                        class="text-body-2 text--disabled font-weight-thin"
                      >
                        {{ template.description }}
                      </p>
                      <div class="d-flex">
                        <v-btn
                          color="primary"
                          class="mr-2"
                        >
                          Activate
                        </v-btn>
                        <v-btn
                          outlined
                          color="primary"
                          class="mr-2"
                        >
                          Preview
                        </v-btn>
                      </div>
                    </v-card-text>
                  </div>
                </base-card>
              </v-col>
            </v-row>

            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="card-title">
                  How to build your success on Market in 3 steps
                </div>
                <p class=" font-weight-medium">
                  The key to your success is the brand you build
                  for yourself through your reputation. We
                  gathered some tips and resources to help you
                  become a leading seller.
                </p>
              </div>
              <div>
                <v-img
                  width="128"
                  height="128"
                  class="d-sm-none d-md-block"
                  src="@/assets/images/avatars/man-1.svg"
                  alt=""
                />
              </div>
            </div>
          </v-card-text>
        </base-card>

        <base-card>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div class="card-title mb-0">
                  How to build your success on Market in 3 steps
                </div>
              </v-col>
              <v-col
                cols="12"
                lg="4"
                class="text-18-left text-center"
              >
                <v-icon
                  class="primary--text mb-2"
                >
                  mdi-microphone-outline
                </v-icon>
                <p class="heading-label ma-0 ">
                  Get Noticed
                </p>
                <p class="text--disabled">
                  Tap into the power of social media by sharing
                  your Gig, and
                  <a
                    class="mr-1"
                    href="#"
                  >get expert help</a>to
                  grow your impact.
                </p>
                <v-btn
                  class=""
                  outlined
                  color="primary"
                >
                  Share Your Gigs
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                lg="4"
                class="text-18-left text-center"
              >
                <v-icon
                  class="info--text mb-2"
                >
                  mdi-book-open-variant
                </v-icon>
                <p class="heading-label ma-0 ">
                  GET MORE SKILLS & EXPOSURE
                </p>
                <p class="text--disabled">
                  Hone your skills and expand your knowledge with
                  online courses. You’ll be able to offer more .
                </p>
                <v-btn
                  class=""
                  outlined
                  color="primary"
                >
                  Explore Learn
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                lg="4"
                class="text-18-left text-center"
              >
                <v-icon
                  class="warning--text mb-2"
                >
                  mdi-trophy
                </v-icon>
                <p class="heading-label ma-0 ">
                  GET NOTICED
                </p>
                <p class="text--disabled">
                  Tap into the power of social media by sharing
                  your Gig, and
                  <a
                    class="mr-1"
                    href="#"
                  >get expert help</a>to
                  grow your impact.
                </p>
                <v-btn
                  class=""
                  outlined
                  color="primary"
                >
                  Watch Free Course
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </base-card>

        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <base-card class="h-full py-5">
              <v-card-text class="d-flex align-start ">
                <v-icon
                  color="primary"
                  class="mr-2"
                >
                  mdi-lightbulb-on-outline
                </v-icon>
                <div>
                  <h5 class="font-weight-bold text-body-1">
                    Tip #1: Business brings business
                  </h5>
                  <p class="ma-0">
                    Every order counts! The more orders you get,
                    the more successful you’ll become.
                  </p>
                </div>
              </v-card-text>
            </base-card>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <base-card class="h-full py-5">
              <v-card-text class="d-flex align-start">
                <v-icon
                  color="primary"
                  class="mr-2"
                >
                  mdi-lightbulb-on-outline
                </v-icon>
                <div>
                  <h5 class="font-weight-bold text-body-1">
                    Tip #2: Keep the cycle going & win buyers
                  </h5>
                  <p class="ma-0">
                    Get an order, provide quality service, and
                    get great reviews. You’ll get more traffic,
                    and more orders.
                  </p>
                </div>
              </v-card-text>
            </base-card>
          </v-col>

          <v-col cols="12">
            <v-carousel
              cycle
              height="100%"
              hide-delimiters
              show-arrows-on-hover
              :light="!$vuetify.theme.dark"
            >
              <v-carousel-item
                v-for="(slide, i) in slides"
                :key="i"
              >
                <v-sheet>
                  <v-row
                    class=""
                    align="center"
                    justify="center"
                  >
                    <div class="d-flex pa-4">
                      <img
                        class="mr-2"
                        height="65"
                        width="65"
                        :src="slide.img"
                        alt=""
                      >
                      <div>
                        <div class="card-title">
                          {{ slide.title }}
                        </div>
                        <p>{{ slide.paragraph }}</p>
                        <v-btn
                          color="primary"
                        >
                          learn more
                        </v-btn>
                      </div>
                    </div>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div-->
</template>

<script>
  import { processChannel, processTemplate } from '@/store/converters'

  export default {
    metaInfo: {
      title: 'Templates',
    },
    data () {
      return {
        item: 0,
        card: {
          title: 'Beats Headphone',
          details: 'Enjoy Premium Sound',
          price: '39',
          img: require('@/assets/images/avatars/man-1.svg'),
        },
        items: [
          { text: 'Ad templates', icon: 'mdi-alpha-a-box-outline' },
          { text: 'Bumpers', icon: 'mdi-file-presentation-box' },
          { text: 'Program Announces', icon: 'mdi-film' },
        ],
        headers: [
          {
            text: 'Id',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: 'Created', value: 'createTime' },
          { text: 'Name', value: 'name' },
          { text: 'NP Channels', value: 'playoutChannelCount' },
          { text: '3P Channels', value: 'thirdPartyChannelCount' },
          { text: 'MT Prefix', value: 'mtPrefix', sortable: false },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        distributionPackages: [],
        newPackageDialog: false,
        newDistribPack: {
          name: '',
          mtPrefix: '',
          mtPrerollPrefix: '',
        },
        rules: {
          nameRules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 1024) || 'Name must be less than 1024 characters',
          ],
        },
        deletedDistribPack: {},
        removeDialog: false,
        reportLoading: false,
        channels: [],
        channel: {
          instance: {},
        },
        templates: [],
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isFormValid () {
        if (!(this.newDistribPack.name.length >= 3 && this.newDistribPack.name.length <= 255)) {
          return false
        }
        return true
      },
      defaultIcon () {
        return '/images/no_logo.jpeg'
      },
      availableTemplates () {
        const result = []
        for (let i = 0; i < this.templates.length; i += 1) {
          const t = this.templates[i]
          if (this.item === 0 && t.type === 'ad-placeholder') {
            result.push(t)
          } else if (this.item === 1 && t.type === 'bumper') {
            result.push(t)
          } else if (this.item === 2 && t.type === 'announce') {
            result.push(t)
          }
        }
        return result
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$store.commit('setPageLoader')

        const channelReqArgs = {
          $expand: 'instance',
        }
        const channelReq = this.$store.dispatch('channels', channelReqArgs)

        Promise.all([channelReq])
          .then((res) => {
            const channels = res[0] || []
            this.channels = channels.map((c) => processChannel(c))
            if (this.channels.length > 0) {
              this.channel = this.channels[0]
            }

            this.getTemplates()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      getTemplates () {
        this.$store.commit('setPageLoader')

        const templateReqArgs = {
          'instance.id[eq]': this.channel.instance.id,
        }
        const templateReq = this.$store.dispatch('templates', templateReqArgs)

        Promise.all([templateReq])
          .then((res) => {
            const templates = res[0] || []
            this.templates = templates.map((t) => processTemplate(t))
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      goToDetails (distribution) {
        this.$router.push({
          name: 'Distribution',
          params: {
            distribution_id: distribution.id,
          },
        })
      },
      newPackage () {
        this.newPackageDialog = true
      },
      saveNewDistribPackage () {
        if (!this.isFormValid) return

        this.$store.commit('setPageLoader')
        const distribPack = {
          name: this.newDistribPack.name,
          mt_prefix: this.newDistribPack.mtPrefix,
          mt_preroll_prefix: this.newDistribPack.mtPrerollPrefix,
        }

        this.$store.dispatch('createDistributionPackage', distribPack)
          .then((pack) => {
            this.$store.commit('showSnackbar', {
              text: 'The distribution package has been successfully created',
              timeout: 3000,
              color: 'success',
            })
            this.goToDetails(pack)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.newPackageDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      openRemoveDialog (pack) {
        this.deletedDistribPack = pack
        this.removeDialog = true
      },
      deleteDistribPack () {
        if (!this.deletedDistribPack.id) return

        this.$store.commit('setPageLoader')
        this.$store.dispatch('deleteDistributionPackage', this.deletedDistribPack.id)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The distribution package has been successfully removed',
              timeout: 6000,
              color: 'success',
            })
            this.getDistributionPackages()
            this.deletedDistribPack = {}
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.removeDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      exportXLS () {
        this.reportLoading = true
        this.$store.dispatch('exportAllDistributions')
          .then((response) => {
            const blob = new Blob([response.data], { type: response.data.type })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'Playout Distributions'
            link.click()
            URL.revokeObjectURL(link.href)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.reportLoading = false
          })
      },
    },
  }
</script>

<style>
@media (min-width: 1200px) {
  .container {
    max-width: 1320px !important;
  }
}
</style>
